// proto/v2/artifact/artifact.proto
//
// Artifact metadata over WS. Binary data (the artifact content itself)
// remains on HTTP — a WS envelope is the wrong shape for a raw binary stream
// with Content-Type headers, so the existing GET
// `/api/v1/research/:researchId/artifacts/:artifactId` stays.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file artifact/artifact.proto (package lvdr.v2.artifact, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file artifact/artifact.proto.
 */
export const file_artifact_artifact: GenFile = /*@__PURE__*/
  fileDesc("ChdhcnRpZmFjdC9hcnRpZmFjdC5wcm90bxIQbHZkci52Mi5hcnRpZmFjdCKlAQoIQXJ0aWZhY3QSEwoLYXJ0aWZhY3RfaWQYASABKAkSEwoLcmVzZWFyY2hfaWQYAiABKAkSDAoEdHlwZRgDIAEoCRIQCghmaWxlbmFtZRgEIAEoCRIOCgZmb3JtYXQYBSABKAkSDwoHY2FwdGlvbhgGIAEoCRIuCgpjcmVhdGVkX2F0GAcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCI5ChRMaXN0QXJ0aWZhY3RzUmVxdWVzdBITCgtyZXNlYXJjaF9pZBgBIAEoCRIMCgR0eXBlGAIgASgJIloKFEFydGlmYWN0TGlzdFJlc3BvbnNlEhMKC3Jlc2VhcmNoX2lkGAEgASgJEi0KCWFydGlmYWN0cxgCIAMoCzIaLmx2ZHIudjIuYXJ0aWZhY3QuQXJ0aWZhY3RCKVonZ2l0aHViLmNvbS9ndnM0Mi9sdmRyL3Byb3RvL3YyL2FydGlmYWN0YgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * Metadata for a single artifact (no binary data).
 *
 * @generated from message lvdr.v2.artifact.Artifact
 */
export type Artifact = Message<"lvdr.v2.artifact.Artifact"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: string research_id = 2;
   */
  researchId: string;

  /**
   * e.g. "diagram", "image", "report_pdf"
   *
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: string filename = 4;
   */
  filename: string;

  /**
   * e.g. "png", "svg"
   *
   * @generated from field: string format = 5;
   */
  format: string;

  /**
   * @generated from field: string caption = 6;
   */
  caption: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.artifact.Artifact.
 * Use `create(ArtifactSchema)` to create a new message.
 */
export const ArtifactSchema: GenMessage<Artifact> = /*@__PURE__*/
  messageDesc(file_artifact_artifact, 0);

/**
 * List artifacts for a research. Type filter is optional; empty = all types.
 *
 * @generated from message lvdr.v2.artifact.ListArtifactsRequest
 */
export type ListArtifactsRequest = Message<"lvdr.v2.artifact.ListArtifactsRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;
};

/**
 * Describes the message lvdr.v2.artifact.ListArtifactsRequest.
 * Use `create(ListArtifactsRequestSchema)` to create a new message.
 */
export const ListArtifactsRequestSchema: GenMessage<ListArtifactsRequest> = /*@__PURE__*/
  messageDesc(file_artifact_artifact, 1);

/**
 * @generated from message lvdr.v2.artifact.ArtifactListResponse
 */
export type ArtifactListResponse = Message<"lvdr.v2.artifact.ArtifactListResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: repeated lvdr.v2.artifact.Artifact artifacts = 2;
   */
  artifacts: Artifact[];
};

/**
 * Describes the message lvdr.v2.artifact.ArtifactListResponse.
 * Use `create(ArtifactListResponseSchema)` to create a new message.
 */
export const ArtifactListResponseSchema: GenMessage<ArtifactListResponse> = /*@__PURE__*/
  messageDesc(file_artifact_artifact, 2);

